import storageAPI from './storageAPI';
import Papa from 'papaparse';
import _ from 'lodash';
import { filesURL } from 'config';

const parseCsv = (file) =>
  new Promise((resolve, reject) => {
    Papa.parse(file, {
      encoding: 'ISO-8859-1',
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        if (results.errors && results.errors.length) {
          console.warn('[DirectionsGrid][csv][parse-warnings]', results.errors);
        }
        resolve(results.data || []);
      },
      error: reject,
    });
  });

export default {
  directionsGrid: {
    getHelpers: async (localeCode) => {
      const helpersPath = 'Images/TemplateGraphics/DirectionsGrid/Helpers';
      const filePath = `${helpersPath}/helpers.csv`;
      const file = await storageAPI.getFile(filePath, false, {
        responseType: 'blob',
      });
      const rows = await parseCsv(file);

      return _.chain(rows)
        .map((helper) => {
          const alias = String(helper.alias || '').trim();
          if (!alias) return null;

          return {
            ...helper,
            alias,
            text:
              helper[`text_${localeCode}`] ||
              helper.text_en ||
              '',
            audioUrl: `${filesURL}/${helpersPath}/Audio/${localeCode}/${alias}.mp3`,
          };
        })
        .compact()
        .keyBy('alias')
        .value();
    },

    getAssets: async (localeCode) => {
      const assetsPath = 'Images/TemplateGraphics/DirectionsGrid/Assets';
      const filePath = `${assetsPath}/assets.csv`;
      const file = await storageAPI.getFile(filePath, false, {
        responseType: 'blob',
      });
      const rows = await parseCsv(file);

      return _.chain(rows)
        .map((asset) => {
          const alias = String(asset.alias || '').trim();
          const sourceType = String(asset.type || '').trim();
          const type = sourceType.toUpperCase();
          if (!alias || !sourceType) return null;

          const imageFilename = String(
            asset.imageFilename ||
            asset.image ||
            `${alias}.jpg`
          ).trim();

          return {
            ...asset,
            alias,
            type,
            text:
              asset[`text_${localeCode}`] ||
              asset.text_en ||
              '',
            audioUrl: `${filesURL}/${assetsPath}/${sourceType}/Audio/${localeCode}/${alias}.mp3`,
            imageUrl: `${filesURL}/${assetsPath}/${sourceType}/Images/${imageFilename}`,
          };
        })
        .compact()
        .groupBy('type')
        .value();
    },
  },
};
